<app-select-searching-input  [noOptionText]="'-- Todos --'"
    [defaultValue]="'0'" [name]="this.name" [nameSearching]="this.nameSearching" [form]="this.form"
    [label]="'Filtro por financiador'" [elements]="this.financiers" [placeholderNoValue]="'Sin resultados'"
    [placeholderSearching]="'Buscar financiador...'">
</app-select-searching-input>
